import { render, staticRenderFns } from "./IssuesDetailsDocsList.vue?vue&type=template&id=f8544322"
import script from "./IssuesDetailsDocsList.vue?vue&type=script&lang=js"
export * from "./IssuesDetailsDocsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports